import { render } from "./RtxFail_pg.vue?vue&type=template&id=7568d0e8&scoped=true"
import script from "./RtxFail_pg.vue?vue&type=script&lang=js"
export * from "./RtxFail_pg.vue?vue&type=script&lang=js"

import "./RtxFail_pg.vue?vue&type=style&index=0&id=7568d0e8&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7568d0e8"]])

export default __exports__